export default "__VITE_ASSET__BPP6Wzug__"